<template>
  <div class="settings-instruction">
    <h2 class="headline">Cookies alert settings</h2>

    <v-form v-if="isLoaded" class="form">
      <v-layout row>
        <v-card class="input">
          <content-editor
            label="Text"
            v-model="cookiesAlertData.text"
            :error="$v.cookiesAlertData.text"
            @input="$v.cookiesAlertData.text.$touch()"
            @blur="$v.cookiesAlertData.text.$touch()"
          />
        </v-card>
      </v-layout>
      <v-layout row>
        <v-card class="input">
          <content-editor
            label="Button text"
            v-model="cookiesAlertData.buttonText"
            :error="$v.cookiesAlertData.buttonText"
            @input="$v.cookiesAlertData.buttonText.$touch()"
            @blur="$v.cookiesAlertData.buttonText.$touch()"
          />
        </v-card>
        <v-card class="input">
          <content-editor
            label="Link title"
            v-model="cookiesAlertData.linkTitle"
            :error="$v.cookiesAlertData.linkTitle"
            @input="$v.cookiesAlertData.linkTitle.$touch()"
            @blur="$v.cookiesAlertData.linkTitle.$touch()"
          />
        </v-card>
      </v-layout>
      <v-layout row>
        <v-card class="input">
          <content-editor
            label="Button hover text"
            v-model="cookiesAlertData.buttonHoverText"
            :error="$v.cookiesAlertData.buttonHoverText"
            @input="$v.cookiesAlertData.buttonHoverText.$touch()"
            @blur="$v.cookiesAlertData.buttonHoverText.$touch()"
          />
        </v-card>
        <v-card class="input" offset-xs1>
          <content-editor
            label="Link hover title"
            v-model="cookiesAlertData.linkHoverTitle"
            :error="$v.cookiesAlertData.linkHoverTitle"
            @input="$v.cookiesAlertData.linkHoverTitle.$touch()"
            @blur="$v.cookiesAlertData.linkHoverTitle.$touch()"
          />
        </v-card>
      </v-layout>
      <v-layout row>
        <v-flex xs10>
          <content-field
            label="Link http://..."
            v-model="cookiesAlertData.link"
            :error="$v.cookiesAlertData.link"
          />
        </v-flex>
      </v-layout>

      <e-color-picker
        label="component background color"
        :value="cookiesAlertData.componentBgColor"
        @colorChange="onComponentBackgroundColorChange"
      />

      <e-color-picker
        label="button background color"
        :value="cookiesAlertData.buttonBgColor"
        @colorChange="onBackgroundButtonColorChange"
      />

      <e-color-picker
        label="button background hover color"
        :value="cookiesAlertData.buttonBgHoverColor"
        @colorChange="onBackgroundHoverButtonColorChange"
      />

      <v-btn
        class="btn_submit"
        color="success"
        @click="submitForm"
        :disabled="errorValidation"
      >Update settings
      </v-btn>

    </v-form>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import EColorPicker from '@/components/shared/EColorPicker'
import { required, url } from 'vuelidate/lib/validators'
import { path, clone } from 'ramda'

export default {
  name: 'cookiesAlert',
  components: {
    EColorPicker
  },
  data () {
    return {
      cookiesAlertData: {
        text: '',
        linkTitle: '',
        linkHoverTitle: '',
        link: '',
        buttonText: '',
        buttonHoverText: '',
        buttonBgColor: '',
        buttonBgHoverColor: '',
        componentBgColor: ''
      },
      isLoaded: false
    }
  },
  validations () {
    return {
      cookiesAlertData: {
        text: { required },
        linkTitle: { required },
        linkHoverTitle: { required },
        link: { required, url },
        buttonText: { required },
        buttonHoverText: { required }
      }
    }
  },
  computed: {
    ...mapGetters(['getSettings']),
    getCookiesAlertSettings () {
      return path(['cookieAlertSetting', 'metadataObject'], this.getSettings)
    },
    errorValidation () {
      return this.$v.cookiesAlertData.$invalid
    }
  },
  watch: {
    getCookiesAlertSettings () {
      this.setFormData()
    }
  },
  methods: {
    ...mapActions([
      'updateCookiesAlertSettings',
      'fetchGeneralSettings'
    ]),
    path,
    setFormData () {
      this.cookiesAlertData = clone(this.getCookiesAlertSettings)
      this.isLoaded = true
    },
    async requestData () {
      if (!this.getSettings) {
        try {
          await this.fetchGeneralSettings()
          this.setFormData()
        } catch (err) {
          throw err
        }
      }
      else {
        this.setFormData()
      }
    },
    submitForm () {
      this.$v.cookiesAlertData.$touch()
      if (this.$v.cookiesAlertData.$invalid) return
      this.updateCookiesAlertSettings({ 'metadata': this.cookiesAlertData })
    },
    onComponentBackgroundColorChange (newColor) {
      this.cookiesAlertData.componentBgColor = newColor
    },
    onBackgroundButtonColorChange (newColor) {
      this.cookiesAlertData.buttonBgColor = newColor
    },
    onBackgroundHoverButtonColorChange (newColor) {
      this.cookiesAlertData.buttonBgHoverColor = newColor
    }
  },
  created () {
   this.requestData()
  }
}
</script>

<style lang="scss" scoped>
/deep/ .jodit_sticky .jodit_toolbar {
  position: static !important;
}

.input,
.headline {
  max-width: 480px;
}

.input:first-child {
  margin-right: 10px;
}

.input:last-child {
  margin-left: 10px;
}

.form {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.headline {
  margin-bottom: 20px;
  text-align: left;
}

.card {
  padding: 10px;
  margin-bottom: 15px;
}

.btn {
  &_submit {
    margin: 0 auto;
    margin-top: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/GeneralSettings/CookiesAlert/index.vue